module.exports = __webpack_public_path__ + "img/f3-card-3.2ba39634.png";